import { Link } from "react-router-dom";
import type { LinkProps } from "react-router-dom";
import { usePortalPath } from "../context/PortalNavContext";

export interface PortalLinkProps extends Omit<LinkProps, "to"> {
  /** Client path ("/my-services"); prefixed inside the consultant read-through. */
  to: string;
}

/**
 * A react-router Link for client pages. Pages always pass client paths; inside
 * the consultant read-through PortalPrefixContext keeps the link under
 * /consultant/clients/:orgId/portal instead of leaving the portal.
 */
export function PortalLink({ to, ...rest }: PortalLinkProps) {
  const href = usePortalPath(to);
  return <Link {...rest} to={href} />;
}
